import * as React from "react";
import Viewer from "react-viewer";

function normalizeSrc(raw: string) {
  if (!raw) return "";

  if (/^https?:\/\//i.test(raw)) return raw;

  const parts = raw.split("/public/");
  if (parts.length >= 2 && parts[1]) {
    return `https://peetsunbae.com/${encodeURI(parts[1])}`;
  }

  if (raw.startsWith("/")) {
    return `https://peetsunbae.com${raw}`;
  }

  return raw;
}

type ImageModal2Props =
    {
        open: boolean;
        handleClose: () => void;
        isMultiple?: boolean;
        src: string[];
        startIndex?: number;
    };

const ImageModal2: React.FC<ImageModal2Props> = (props) => {
  const { open, handleClose } = props;

  const images = React.useMemo(() => {

      const alt = "크기 조절 : 마우스 휠 / 종료 : ESC"

      return props.src.map((s) => ({
          src: normalizeSrc(s),
          alt,
      }));

  }, [props]);

  const activeIndex = props.isMultiple
    ? props.startIndex ?? 0
    : 0;

  React.useEffect(() => {
    console.log("ImageModal2 images:", images, "open:", open);
  }, [images, open]);

  return (
    <Viewer
      key={images.map((i) => i.src).join("|") || "empty"}
      visible={open}
      onClose={handleClose}
      images={images}
      activeIndex={activeIndex}
      rotatable
      scalable
      zoomSpeed={0.1}
      noImgDetails
      noNavbar
      noResetZoomAfterChange
      noClose
      onMaskClick={handleClose} 
      zIndex={999999999}
    />
  );
};

export default ImageModal2;